(() => {
  const dialog = document.querySelector('[data-fere-email-offer]');
  if (!dialog) return;

  const storageKey = 'fere-email-offer-state-v1';
  const closeButton = dialog.querySelector('[data-fere-email-offer-close]');
  const emailInput = dialog.querySelector('input[type="email"]');
  const isSuccess = dialog.dataset.success === 'true';
  const hasErrors = dialog.dataset.hasErrors === 'true';
  let lastFocusedElement = null;
  let deferredByConsent = false;
  let consentReleaseTimer = null;

  const consentIsVisible = () => {
    const consent = document.querySelector('#shopify-pc__banner, #shopify-pc__prefs__dialog');
    if (!consent) return false;
    const styles = window.getComputedStyle(consent);
    const rect = consent.getBoundingClientRect();
    return !consent.hidden && styles.display !== 'none' && styles.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  };

  const readState = () => {
    try {
      return JSON.parse(window.localStorage.getItem(storageKey) || 'null');
    } catch (_error) {
      return null;
    }
  };

  const writeState = (value) => {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(value));
    } catch (_error) {
      // The offer remains functional when storage is unavailable.
    }
  };

  const show = () => {
    if (consentIsVisible()) {
      deferredByConsent = true;
      return;
    }
    if (dialog.open) return;
    lastFocusedElement = document.activeElement;
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    window.setTimeout(() => {
      (emailInput || closeButton)?.focus({ preventScroll: true });
    }, 0);
  };

  const close = (remember = true) => {
    if (remember && !isSuccess) {
      writeState({ status: 'dismissed', timestamp: Date.now() });
    }
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
    lastFocusedElement?.focus?.({ preventScroll: true });
  };

  closeButton?.addEventListener('click', () => close(true));
  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    close(true);
  });
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) close(true);
  });

  const consentObserver = new MutationObserver(() => {
    if (consentIsVisible()) {
      if (dialog.open) close(false);
      deferredByConsent = true;
      window.clearTimeout(consentReleaseTimer);
      return;
    }

    if (!deferredByConsent) return;
    window.clearTimeout(consentReleaseTimer);
    consentReleaseTimer = window.setTimeout(() => {
      deferredByConsent = false;
      show();
    }, 2400);
  });

  consentObserver.observe(document.documentElement, {
    attributes: true,
    childList: true,
    subtree: true,
  });

  if (isSuccess) {
    writeState({ status: 'subscribed', timestamp: Date.now() });
    show();
    return;
  }

  if (hasErrors || window.location.hash === '#fere-email-offer') {
    show();
    return;
  }

  const state = readState();
  if (state?.status === 'subscribed') return;

  const thirtyDays = 30 * 24 * 60 * 60 * 1000;
  if (state?.status === 'dismissed' && Date.now() - Number(state.timestamp || 0) < thirtyDays) return;

  window.setTimeout(show, 4500);
})();
